const ADDRESS_LS_KEY = 'com.makemytrip.railways.traveller.address';

export {
  ADDRESS_LS_KEY,
};
